import React, { createContext, useContext, useState } from 'react';

export const formatCurrency = (num) =>
  '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const buildInitialEntries = () => [
  {
    id: 'CBP-8829102A',
    date: '2026-03-12',
    broker: 'Expeditors',
    recoveryValue: 4500.00,
    deficiencyValue: 5450.00,
    indicators: ['fail', 'fail', 'hitl'],
    classVectors: [
      { name: 'Pivot Row vs. 7501 Line Reconciliation', status: 'pass' },
      { name: '7501 Internal Arithmetic Integrity (Box 35)', status: 'pass' },
      { name: 'Base HTS & Duty Rate Integrity', status: 'pass' },
      { name: 'Chapter 99 & Sec 232 / 301 Audits', status: 'recovery' },
      { name: 'Section 122 Offsets', status: 'pass' },
      { name: 'Exclusion Monitoring (USTR)', status: 'pass' },
    ],
    typeAVectors: [
      { name: 'Incoterm / Freight Valuation Variance', status: 'recovery' },
      { name: 'Special Program Indicator (SPI) Omissions', status: 'pass' },
      { name: 'Country of Origin (COO) Consistency', status: 'pass' },
      { name: 'MPF / HMF Cap Violations', status: 'pass' },
      { name: 'UOM / Quantity Integrity', status: 'pass' },
      { name: 'Date of Export / FX Conversion', status: 'risk' },
    ],
    typeBVectors: [
      { name: 'Assists & Royalties Predictor', status: 'hitl' },
      { name: 'Related Party / Transfer Pricing Predictor', status: 'pass' },
      { name: 'Buying Commission Predictor', status: 'pass' },
      { name: 'First Sale for Export Predictor', status: 'pass' },
    ],
    emailTo: 'imports@expeditors.com',
    emailSubject: 'PSC Required: Entry CBP-8829102A - Form 7501 Corrections',
    emailIntro: 'Please file a Post-Summary Correction (PSC) for Entry CBP-8829102A based on the following findings:',
    emailOutro: 'Please amend the entry and confirm upon transmission.',
    exceptions: [
      {
        title: 'Triage Required: Chapter 99 & Sec 232 / 301 Audits',
        type: 'recovery',
        value: 4500.00,
        cleared: false,
        items: [
          { part: 'PN-8890A Actuator Assembly', declared: '9903.88.01 (25%)', target: '9902.14.00 (0%)', flag: 'Ch 99 Mismatch', vectorTarget: 'Chapter 99 & Sec 232 / 301 Audits' },
        ],
        summary: '[RECOVERY ALERT] Statutory exemption missed. Active USTR exclusion found. Duty Base: $18,000. Broker paid 25%. Correct rate is 0%. (Calculation: $18,000 x 25% = $4,500 Duty Recovery).',
        emailSnippet: '<strong>[RECOVERY ALERT] Chapter 99 Error:</strong> Statutory exemption missed. Active USTR exclusion found. Duty Base: $18,000. Broker paid 25%. Correct rate is 0%. (Calculation: $18,000 x 25% = $4,500 Duty Recovery).<br><br>',
      },
      {
        title: 'Triage Required: Incoterm / Freight Valuation Variance',
        type: 'risk',
        value: 450.00,
        cleared: false,
        items: [
          { part: 'Header Level (Freight)', declared: '$4,500.00 Deducted', target: '$0.00 Deducted (FCA)', flag: 'Illegal Deduction', vectorTarget: 'Incoterm / Freight Valuation Variance' },
        ],
        summary: '[COMPLIANCE RISK] Broker illegally deducted freight charges from an FCA invoice. Duty base undervalued by $4,500. (Calculation: $4,500 x 10% Duty Rate = $450 Duty Deficiency).',
        emailSnippet: '<strong>[COMPLIANCE RISK] Valuation Error:</strong> Broker illegally deducted freight charges from an FCA invoice. Duty base undervalued by $4,500. (Calculation: $4,500 x 10% Duty Rate = $450 Duty Deficiency).<br><br>',
      },
      {
        title: 'Triage Required: Date of Export / FX Conversion',
        type: 'risk',
        value: 5000.00,
        cleared: false,
        items: [
          { part: 'FX Rate Date', declared: '2026-03-12', target: '2026-03-15', flag: 'FX Date Error', vectorTarget: 'Date of Export / FX Conversion' },
        ],
        summary: '[COMPLIANCE RISK] FX Date Error. Broker used Arrival Date instead of Sailing Date. Duty base undervalued by $50,000. (Calculation: $50,000 x 10% Duty Rate = $5,000 Duty Deficiency).',
        emailSnippet: '<strong>[COMPLIANCE RISK] FX Date Error:</strong> Broker used Arrival Date instead of Sailing Date. Duty base undervalued by $50,000. (Calculation: $50,000 x 10% Duty Rate = $5,000 Duty Deficiency).<br><br>',
      },
    ],
    hitl: [
      {
        title: 'Agentic Predictor: Assists & Royalties',
        desc: '[HITL REQUIRED] Potential Assist/Royalty detected. Upload Vendor Agreement to verify if undeclared engineering/tooling costs must be added to the dutiable value.',
        actionTitle: 'Verification Required:',
        actionDesc: 'A tooling amortization line was flagged on the Commercial Invoice.',
        btnText: 'Upload Vendor Agreement',
        vectorsTarget: 'Assists & Royalties Predictor',
        type: 'hitl',
        value: 0,
        cleared: false,
        validated: false,
      },
    ],
  },
  {
    id: 'CBP-4492019B',
    date: '2026-03-14',
    broker: 'Kuehne+Nagel',
    recoveryValue: 0.00,
    deficiencyValue: 0.00,
    indicators: ['pass', 'pass', 'pass'],
    classVectors: [
      { name: 'Pivot Row vs. 7501 Line Reconciliation', status: 'pass' },
      { name: '7501 Internal Arithmetic Integrity (Box 35)', status: 'pass' },
      { name: 'Base HTS & Duty Rate Integrity', status: 'pass' },
      { name: 'Chapter 99 & Sec 232 / 301 Audits', status: 'pass' },
      { name: 'Section 122 Offsets', status: 'pass' },
      { name: 'Exclusion Monitoring (USTR)', status: 'pass' },
    ],
    typeAVectors: [
      { name: 'Incoterm / Freight Valuation Variance', status: 'pass' },
      { name: 'Special Program Indicator (SPI) Omissions', status: 'pass' },
      { name: 'Country of Origin (COO) Consistency', status: 'pass' },
      { name: 'MPF / HMF Cap Violations', status: 'pass' },
      { name: 'UOM / Quantity Integrity', status: 'pass' },
      { name: 'Date of Export / FX Conversion', status: 'pass' },
    ],
    typeBVectors: [
      { name: 'Assists & Royalties Predictor', status: 'pass' },
      { name: 'Related Party / Transfer Pricing Predictor', status: 'pass' },
      { name: 'Buying Commission Predictor', status: 'pass' },
      { name: 'First Sale for Export Predictor', status: 'pass' },
    ],
    emailTo: '',
    emailSubject: '',
    emailIntro: '',
    emailOutro: '',
    exceptions: [],
    hitl: [],
  },
  {
    id: 'CBP-7734110C',
    date: '2026-03-15',
    broker: 'CH Robinson',
    recoveryValue: 0.00,
    deficiencyValue: 0.00,
    indicators: ['fail', 'fail', 'pass'],
    classVectors: [
      { name: 'Pivot Row vs. 7501 Line Reconciliation', status: 'risk' },
      { name: '7501 Internal Arithmetic Integrity (Box 35)', status: 'pass' },
      { name: 'Base HTS & Duty Rate Integrity', status: 'pass' },
      { name: 'Chapter 99 & Sec 232 / 301 Audits', status: 'pass' },
      { name: 'Section 122 Offsets', status: 'pass' },
      { name: 'Exclusion Monitoring (USTR)', status: 'pass' },
    ],
    typeAVectors: [
      { name: 'Incoterm / Freight Valuation Variance', status: 'pass' },
      { name: 'Special Program Indicator (SPI) Omissions', status: 'pass' },
      { name: 'Country of Origin (COO) Consistency', status: 'pass' },
      { name: 'MPF / HMF Cap Violations', status: 'pass' },
      { name: 'UOM / Quantity Integrity', status: 'risk' },
      { name: 'Date of Export / FX Conversion', status: 'pass' },
    ],
    typeBVectors: [
      { name: 'Assists & Royalties Predictor', status: 'pass' },
      { name: 'Related Party / Transfer Pricing Predictor', status: 'pass' },
      { name: 'Buying Commission Predictor', status: 'pass' },
      { name: 'First Sale for Export Predictor', status: 'pass' },
    ],
    emailTo: 'compliance@chrobinson.com',
    emailSubject: 'PSC Required: Entry CBP-7734110C - Form 7501 Corrections',
    emailIntro: 'Please file a Post-Summary Correction for Entry CBP-7734110C based on the following findings:',
    emailOutro: 'Please audit the entry and confirm upon transmission.',
    exceptions: [
      {
        title: 'Triage Required: Pivot Row vs. 7501 Line Reconciliation',
        type: 'risk',
        value: 0,
        cleared: false,
        items: [
          { part: 'Entry Header', declared: '14 Lines Filed', target: '15 Rows in Pivot', flag: 'Dropped Line Item', vectorTarget: 'Pivot Row vs. 7501 Line Reconciliation' },
        ],
        summary: '[COMPLIANCE RISK] Structural mismatch detected. Pivot instructed [15] lines; Broker filed [14] lines. Unauthorized line-item consolidation or omission. CF-28 Audit Risk.',
        emailSnippet: '<strong>[COMPLIANCE RISK] Line Reconciliation Error:</strong> Structural mismatch detected. Pivot instructed [15] lines; Broker filed [14] lines. Unauthorized line-item consolidation or omission. CF-28 Audit Risk.<br><br>',
      },
      {
        title: 'Triage Required: UOM / Quantity Integrity',
        type: 'risk',
        value: 0,
        cleared: false,
        items: [
          { part: 'PN-4412B Titanium Landing Strut', declared: '1,000 KGS', target: '1,000 LBS', flag: 'UOM Mismatch', vectorTarget: 'UOM / Quantity Integrity' },
        ],
        summary: '[COMPLIANCE RISK] UOM reporting mismatch. Broker filed [KGS]. USITC database strictly mandates [LBS] for HTS [8803.30.00]. Census Bureau statistical reporting violation.',
        emailSnippet: '<strong>[COMPLIANCE RISK] UOM Error:</strong> UOM reporting mismatch. Broker filed [KGS]. USITC database strictly mandates [LBS] for HTS [8803.30.00]. Census Bureau statistical reporting violation.<br><br>',
      },
    ],
    hitl: [],
  },
];

const DASIContext = createContext(null);

export const DASIProvider = ({ children }) => {
  const [entries, setEntries] = useState(buildInitialEntries);
  const [currentIndex, setCurrentIndex] = useState(0);

  const clearException = (entryIndex, exceptionIndex, vectorTarget, exceptionValue, exceptionType) => {
    setEntries((prev) =>
      prev.map((e, i) => {
        if (i !== entryIndex) return e;

        const newExceptions = e.exceptions.map((ex, j) =>
          j === exceptionIndex ? { ...ex, cleared: true } : ex
        );

        const clearVectorInArr = (arr) =>
          arr.map((v) => v.name === vectorTarget ? { ...v, status: 'cleared' } : v);

        let newRecovery = e.recoveryValue;
        let newDeficiency = e.deficiencyValue;
        if (exceptionValue > 0) {
          if (exceptionType === 'recovery') newRecovery = Math.max(0, newRecovery - exceptionValue);
          else if (exceptionType === 'risk') newDeficiency = Math.max(0, newDeficiency - exceptionValue);
        }

        return {
          ...e,
          exceptions: newExceptions,
          classVectors: clearVectorInArr(e.classVectors),
          typeAVectors: clearVectorInArr(e.typeAVectors),
          typeBVectors: clearVectorInArr(e.typeBVectors),
          recoveryValue: newRecovery,
          deficiencyValue: newDeficiency,
        };
      })
    );
  };

  const clearHitl = (entryIndex, hitlIndex, vectorsTarget) => {
    setEntries((prev) =>
      prev.map((e, i) => {
        if (i !== entryIndex) return e;

        const newHitl = e.hitl.map((h, j) =>
          j === hitlIndex ? { ...h, cleared: true } : h
        );

        const clearVectorInArr = (arr) =>
          arr.map((v) => v.name === vectorsTarget ? { ...v, status: 'cleared' } : v);

        return {
          ...e,
          hitl: newHitl,
          classVectors: clearVectorInArr(e.classVectors),
          typeAVectors: clearVectorInArr(e.typeAVectors),
          typeBVectors: clearVectorInArr(e.typeBVectors),
        };
      })
    );
  };

  const validateHitl = (entryIndex, hitlIndex) => {
    setEntries((prev) =>
      prev.map((e, i) => {
        if (i !== entryIndex) return e;
        return {
          ...e,
          hitl: e.hitl.map((h, j) => j === hitlIndex ? { ...h, validated: true } : h),
        };
      })
    );
  };

  return (
    <DASIContext.Provider value={{ entries, currentIndex, setCurrentIndex, clearException, clearHitl, validateHitl }}>
      {children}
    </DASIContext.Provider>
  );
};

export const useDASI = () => useContext(DASIContext);
